import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { gestApi } from "../GestAuthContext";
import { money } from "./shared";

export default function RicaviCard({ cantiereId, onChanged }) {
  const [data, setData] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    const { data: d } = await gestApi.get(`/ricavi/${cantiereId}`);
    setData(d);
    setForm({
      valore_contratto: d.valore_contratto || 0,
      varianti: d.varianti || 0,
      extra: d.extra || 0,
      acconti: d.acconti || 0,
      saldo_previsto: d.saldo_previsto || 0,
      note: d.note || "",
    });
  }, [cantiereId]);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setBusy(true);
    try {
      await gestApi.put("/ricavi", { ...form, cantiere_id: cantiereId,
        valore_contratto: Number(form.valore_contratto), varianti: Number(form.varianti),
        extra: Number(form.extra), acconti: Number(form.acconti), saldo_previsto: Number(form.saldo_previsto) });
      toast.success("Ricavi aggiornati");
      setEditing(false);
      await load();
      onChanged?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally { setBusy(false); }
  };

  if (!data || !form) return null;
  const tot = Number(form.valore_contratto || 0) + Number(form.varianti || 0) + Number(form.extra || 0);

  return (
    <div className="bg-white rounded-2xl p-5 border border-black/[0.04] shadow-sm" data-testid="gest-ricavi-card">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[13px] font-semibold text-[#0a1420]">Ricavi</div>
        {!editing ? (
          <button onClick={() => setEditing(true)} data-testid="gest-ricavi-edit" className="text-[12px] text-[#0a1420] hover:underline">Modifica</button>
        ) : (
          <div className="flex gap-2">
            <button onClick={() => { setEditing(false); load(); }} className="text-[12px] text-[#6e6e73]">Annulla</button>
            <button onClick={save} disabled={busy} data-testid="gest-ricavi-save" className="text-[12px] font-semibold text-[#0a1420]">{busy ? "…" : "Salva"}</button>
          </div>
        )}
      </div>
      <div className="grid grid-cols-2 gap-3">
        {[
          ["valore_contratto", "Valore contratto"],
          ["varianti", "Varianti"],
          ["extra", "Extra"],
          ["acconti", "Acconti incassati"],
          ["saldo_previsto", "Saldo previsto"],
        ].map(([k, l]) => (
          <div key={k}>
            <div className="text-[11px] text-[#6e6e73] uppercase tracking-wider">{l}</div>
            {editing ? (
              <input type="number" step="0.01" value={form[k]} onChange={(e) => setForm((s) => ({ ...s, [k]: e.target.value }))} className="w-full border border-black/10 rounded-lg px-2 py-1 text-[13px] mt-1" />
            ) : (
              <div className="text-[14px] font-semibold text-[#0a1420] mt-0.5">{money(data[k])}</div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-black/5 flex items-center justify-between">
        <div className="text-[12px] text-[#6e6e73]">Totale ricavi</div>
        <div className="text-[16px] font-semibold text-[#0a1420]">{money(tot)}</div>
      </div>
    </div>
  );
}
